const mediaItems = [
  {
    id: 1,
    title: '「航海王」最终章剧情深度解析',
    duration: '15:42',
    views: '128万次播放',
    image: 'https://readdy.ai/api/search-image?query=One%20Piece%20final%20arc%20manga%20analysis%20video%20thumbnail%20style%20with%20dramatic%20pirate%20flag%20and%20treasure%20map%20visuals%2C%20warm%20golden%20tones%2C%20editorial%20review%20layout%20with%20manga%20panels%2C%20cinematic%20adventure%20atmosphere&width=600&height=340&seq=media-1&orientation=landscape',
  },
  {
    id: 2,
    title: '2026年最值得期待的10部新番漫画',
    duration: '12:35',
    views: '96万次播放',
    image: 'https://readdy.ai/api/search-image?query=New%20manga%20recommendation%20thumbnail%20with%20vibrant%20colorful%20cover%20art%20collage%2C%20bright%20modern%20anime%20style%2C%20ranking%20list%20design%20with%20glossy%20manga%20volumes%2C%20exciting%20fresh%20atmosphere%20with%20warm%20lighting&width=600&height=340&seq=media-2&orientation=landscape',
  },
  {
    id: 3,
    title: '51漫画APP使用教程：离线下载全攻略',
    duration: '08:20',
    views: '75万次播放',
    image: 'https://readdy.ai/api/search-image?query=Manga%20reading%20app%20tutorial%20video%20thumbnail%20with%20smartphone%20screen%20showing%20download%20interface%2C%20clean%20warm%20amber%20UI%20design%2C%20step%20by%20step%20guide%20visuals%2C%20friendly%20helpful%20atmosphere%2C%20modern%20tech%20aesthetic&width=600&height=340&seq=media-3&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            精彩推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            51漫画下载相关的精选内容与实用指南
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group block bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title} - 51漫画下载`}
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 group-hover:bg-background-50 transition-colors">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-1 bg-black/70 rounded text-xs text-background-50 font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base text-foreground-900 mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-eye-line text-foreground-500 text-sm"></i>
                  </div>
                  <span className="text-xs text-foreground-500">{item.views}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}